/** @jsx jsx */
import { jsx, Flex } from 'theme-ui'
import PropTypes from 'prop-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { options } from './richTextRenderOptions'

const ImageText = ({ data, id }) => {
  const { text, image, imagePlacement } = data.fields
  const ImageTextLeft = (
    <Flex
      id={id}
      sx={{
        flexDirection: ['column', 'column', 'row'], // Column for mobile and tablet and row for desktop
        height: '100%',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          width: '400px', // Set a fixed image height
          height: '400px', // Set a fixed image width
          flexShrink: 0, // Prevent shrinking to allow for fixed dimensions
          marginBottom: [5, 5, 0], // Add a margin underneath img on mobile
          paddingRight: ['0px', '0px', '20px'], // Add right padding on desktop
        }}
      >
        {<img alt="" src={image.fields.file.url} />}
      </Flex>
      <Flex
        sx={{
          flexDirection: 'column',
          width: ['100%', '100%', 'auto'], // Take full width on mobile and tablet, auto width on larger screens for text
          flexGrow: 1, // Allow text to grow to fill remaining space on desktop
        }}
      >
        {documentToReactComponents(text, options)}
      </Flex>
    </Flex>
  )
  const ImageTextRight = (
    <Flex
      id={id}
      sx={{
        flexDirection: ['column', 'column', 'row'],
        height: '100%',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          width: ['100%', '100%', 'auto'],
          flexGrow: 1,
          paddingRight: ['0px', '0px', '20px'],
        }}
      >
        {documentToReactComponents(text, options)}
      </Flex>
      <Flex
        sx={{
          flexDirection: 'column',
          width: '400px',
          height: '400px',
          flexShrink: 0,
          marginBottom: [5, 5, 5],
        }}
      >
        {<img alt="" src={image.fields.file.url} />}
      </Flex>
    </Flex>
  )
  return (
    <div>{imagePlacement === 'Pull-Left' ? ImageTextLeft : ImageTextRight}</div>
  )
}

ImageText.propTypes = {
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
}

export default ImageText
